/**
 * Параметры фильтрации мероприятий
 */

export interface EventsForm {
  /**
   * Мероприятия с датой начала позже указанной (>=)
   * @format date-time
   */
  date_from?: Date;

  /**
   * Мероприятия с датой начала раньше указанной (<=)
   * @format date-time
   */
  date_to?: Date;

  /**
   * Количество записей в выборке
   * @default 16
   */
  limit?: number;

  /**
   * Смещение относительно первого элемента
   * @default 0
   */
  offset?: number;

  /**
   * Полигоны
   */
  ground?: Record<string, boolean>;

  /**
   * Варианты регистрации
   */
  reg_type?: Record<string, boolean>;

  /**
   * Состояния мероприятия
   */
  state?: Record<string, boolean>;

  /**
   * Подтипы мероприятия (обновляются динамически)
   */
  subtype?: Record<string, boolean>;

  /**
   * Глобальные типы мероприятия (обновляются динамически)
   */
  type?: Record<string, boolean>;

  /**
   * Организаторы
   */
  event_host?: Record<string, boolean>;

  /**
   * Организаторы
   */
  my?: boolean;

}

export class EventsDTO {
  /**
   * Мероприятия с датой начала позже указанной (>=)
   * @format date-time
   */
  date_from?: string;

  /**
   * Мероприятия с датой начала раньше указанной (<=)
   * @format date-time
   */
  date_to?: string;

  /**
   * Полигоны
   */
  ground?: string[];

  /**
   * Количество записей в выборке
   * @default 16
   */
  limit?: string;

  /**
   * Смещение относительно первого элемента
   * @default 0
   */
  offset?: string;

  /**
   * Варианты регистрации
   */
  reg_type?: string[];

  /**
   * Состояния мероприятия
   */
  state?: string[];

  /**
   * Подтипы мероприятия (обновляются динамически)
   */
  subtype?: string[];

  /**
   * Глобальные типы мероприятия (обновляются динамически)
   */
  type?: string[];

  /**
   * Организаторы
   */
  event_host?: string[];

  /**
   * Организаторы
   */
  my?: boolean;

  [key: string]: string | number | Date | string[] | boolean | undefined;
}


export interface SortingType {
  my?: string

  // ...
}

function arrayToObject(arr: string[] | undefined): Record<string, boolean> | undefined {
  if (!arr) return undefined;
  return arr.reduce((acc, key) => {
    acc[key] = true;
    return acc;
  }, {} as Record<string, boolean>);
}

function objectToArray(obj: Record<string, boolean> | undefined): string[] | undefined {
  if (!obj) return undefined;
  return Object.entries(obj)
    .filter(([_, value]) => value)
    .map(([key]) => key);
}

const toBackDateFormat = (date: Date) => {
  const isoString = date.toISOString(); // "2025-04-18T08:00:00.000Z"
  return isoString.split('T')[0];

}
export function convertToEventsForm(dto: EventsDTO): EventsForm {
  return {
    limit: Number(dto.limit),
    offset: Number(dto.offset),
    date_from: new Date(dto.date_from || ''),
    date_to: new Date(dto.date_to || ''),
    reg_type: arrayToObject(dto.reg_type),
    state: arrayToObject(dto.state),
    subtype: arrayToObject(dto.subtype),
    type: arrayToObject(dto.type),
    ground: arrayToObject(dto.ground),
    event_host: arrayToObject(dto.event_host),
    my: dto.my
  };
}

export function convertToEventsDTO(form: EventsForm): EventsDTO {

  return {
    limit: form.limit?.toString(),
    offset: form.offset?.toString(),
    date_from: form.date_from && toBackDateFormat(form.date_from),
    date_to: form.date_to && toBackDateFormat(form.date_to),
    reg_type: objectToArray(form.reg_type),
    state: objectToArray(form.state),
    subtype: objectToArray(form.subtype),
    type: objectToArray(form.type),
    ground: objectToArray(form.ground),
    event_host: objectToArray(form.event_host),
    my: form.my
  };
}

export function convertUrlParamsToEventsDTO(params: URLSearchParams): EventsForm {
  return {
    date_from: params.get('date_from') ? new Date(params.get('date_from')!) : undefined,
    date_to: params.get('date_to') ? new Date(params.get('date_to')!) : undefined,
    ground: arrayToObject(params.getAll('ground').length ? params.getAll('ground') : undefined),
    reg_type: arrayToObject(params.getAll('reg_type').length ? params.getAll('reg_type') : undefined),
    state: arrayToObject(params.getAll('state').length ? params.getAll('state') : undefined),
    subtype: arrayToObject(params.getAll('subtype').length ? params.getAll('subtype') : undefined),
    type: arrayToObject(params.getAll('type').length ? params.getAll('type') : undefined),
    event_host: arrayToObject(params.getAll('event_host').length ? params.getAll('event_host') : undefined),
    my: params.get('my') === 'true' ? true : params.get('my') === 'false' ? false : undefined
  };
}